// src/pages/Dashboard/DashboardUser.jsx
import React, { useEffect, useState } from "react";
import NotificationsDisplay from "./NotificationsDisplay";
import { useUser } from "./../../contexts/UserContext";
import { getRoleFromRoleId } from "./../../utils/roleHelper";
import useScrollToTop from "./../../hooks/useScrollToTop";
import { ToastContainer, toast } from "react-toastify";
import ScrollIndicator from "./../../hooks/ScrollIndicator";
import InfoBubble from "./../../components/InfoBubble/InfoBubble";

const DashboardUser = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);
  const [userId, setUserId] = useState(null);

  // Récup userId : d'abord le contexte, sinon localStorage (fallback)
  useEffect(() => {
    if (user?.userId) {
      setUserId(user.userId);
      return;
    }
    try {
      const userData = localStorage.getItem("userInfo");
      if (userData) {
        const userObj = JSON.parse(userData);
        if (userObj?.userId) {
          setUserId(userObj.userId);
          return;
        }
      }
      console.error("L'ID de l'utilisateur n'est pas trouvé");
      toast.error("L'ID de l'utilisateur n'est pas trouvé.");
    } catch (error) {
      console.error(
        "Erreur lors de la lecture des données de l'utilisateur du localStorage:",
        error
      );
      toast.error("Erreur lors de la lecture des données de l'utilisateur.");
    }
  }, [user]);

  if (!userId) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] mt-[140px] dark:text-white">
        <p className="text-sm sm:text-base">
          Vous devez être connecté pour accéder à cette page.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <ScrollIndicator />

      <div className="max-w-5xl mx-auto px-3 sm:px-4">
        <h2 className="text-xs sm:text-sm font-semibold tracking-[0.35em] text-primary text-center uppercase mb-1">
          UTILISATEURS
        </h2>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-widest text-center mb-4 font-montserrat uppercase">
          Notifications
        </h1>

        <InfoBubble title="Votre centre de notifications">
          <p>
            Retrouvez ici toutes les notifications liées à votre compte :
            nouveaux articles, partenaires, nouveaux utilisateurs, acteurs du judo, ... Vous pouvez marquer chaque notification comme lue ou non lue en
            cliquant dessus, ou les supprimer en effectuant un glissement vers la
            droite.
          </p>
        </InfoBubble>
      </div>

      <div className="flex flex-col items-center w-full px-3 sm:px-4 mt-4">
        <div className="w-full max-w-5xl mb-4">
          <NotificationsDisplay userId={userId} />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default DashboardUser;
